/* eslint-disable */
/* tslint:disable */
/* auto-generated vue proxies */
import { defineContainer } from './vue-component-lib/utils';

import type { JSX } from '@ovhcloud/ods-stencil/components/quantity/custom-elements';

import { defineCustomElement as defineOsdsQuantity } from '@ovhcloud/ods-stencil/components/quantity/custom-elements/osds-quantity.js';


export const OsdsQuantity = /*@__PURE__*/ defineContainer<JSX.OsdsQuantity>('osds-quantity', defineOsdsQuantity, [
  'disabled'
]);

